<template>
    <DsModal
        :is-open="isOpen"
        show-close
        size="med"
        dialog
        :title="$t('funnel.analysis.add.contacts.title')"
        class="add-contact-to-automation-modal"
        @close="closeAddContactToAutomation"
    >
        <span data-qa="add-contacts-description">
            {{ $tc('funnel.analysis.add.contacts.description', totalSize, { count: totalSize }) }}
        </span>

        <div class="button-row-add-contact">
            <DsFilledButton
                class="add-contact-button"
                @click="addContactToAutomation"
            >
                {{ $t('funnel.analysis.add.contacts.yes') }}
            </DsFilledButton>
            <DsOutlineButton
                class="cancel-add-contact-button"
                @click="doNotAddContactToAutomation"
            >
                {{ $t('funnel.analysis.add.contacts.no') }}
            </DsOutlineButton>
        </div>
        <DsCheckbox
            v-model="addContactsCheckbox"
            :label="$t('funnel.analysis.dismiss.modal')"
            data-qa="add-contacts-checkbox"
            @input="updateDismissAddContacts"
        />
        <span class="contact-label">
            {{ $t('funnel.analysis.contacts.label') }}
        </span>
        <div class="contact-wrapper">
            <DsListItem
                v-for="(contact, i) in contactsInfo"
                :key="i"
                :title="contact.name"
                :short-description="contact.email"
                class="add-contact-list"
                data-qa="add-contact-list"
            >
                <template #leading>
                    <DsAvatar :email="contact.email" />
                </template>
            </DsListItem>
            <AddContactPaginationControl
                :total-count="totalSize"
                :limit="limit"
                :offset="offset"
                @page="updatePage"
            />
        </div>
    </DsModal>
</template>

<script>
import AddContactPaginationControl from '../addContactPaginationControl/AddContactPaginationControl.vue';
import { getContactsInfoKonva } from '../../campaign.api';
import { ADD_CONTACT_LIMIT } from '../../utils/editor.constants';

export default {
    components: {
        AddContactPaginationControl,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            required: true,
        },
        draftXml: {
            type: String,
            default: '',
        },
    },

    emits: ['update-dismiss-add-contacts', 'set-add-contact-to-automation', 'close-add-contact-to-automation'],

    data() {
        return {
            addContactsCheckbox: false,
            pageToken: 1,
            limit: Number(this.pageSize) > ADD_CONTACT_LIMIT ? Number(this.pageSize) : ADD_CONTACT_LIMIT,
            contactsInfo: [],
            pageSizes: 6,
            totalPages: 0,
            totalSize: 0,
            offset: 0,
        };
    },

    watch: {
        offset() {
            this.loadContactsInfo();
        },
    },

    mounted() {
        this.loadContactsInfo();
    },

    methods: {
        async loadContactsInfo() {
            const data = await getContactsInfoKonva(this.funnelId, this.pageToken, this.pageSizes, this.draftXml);

            this.contactsInfo = data.contacts;
            this.totalSize = data.totalSize;
            this.pageToken = data.nextPage;
            this.totalPages = data.pages;
        },

        updatePage({ offset }) {
            this.offset = offset;
        },

        addContactToAutomation() {
            this.$emit('set-add-contact-to-automation', true);
        },

        updateDismissAddContacts() {
            this.$emit('update-dismiss-add-contacts', this.addContactsCheckbox);
        },

        doNotAddContactToAutomation() {
            this.$emit('set-add-contact-to-automation', false);
        },

        closeAddContactToAutomation() {
            this.$emit('close-add-contact-to-automation');
        },
    },
};
</script>

<style lang="scss">
.add-contact-to-automation-modal {
    div.modal-body {
        padding: 0;
    }

    span.add-to-contacts-description {
        margin: $spacing-125;
    }

    div.button-row-add-contact {
        padding-top: $spacing-150;
    }

    div.contact-wrapper {
        border-top: px-to-rem(0.5) solid $color-gray-200;
        margin-top: $spacing-125;
    }

    button.button.add-contact-button {
        margin-right: $spacing-125;
    }

    span.contact-label{
        font-weight: bold;
    }

    .avatar.default {
        margin-right: $spacing-200;
    }

    .border-partial .list-item-info {
        padding-bottom: 0;
    }

    .list-item.add-contact-list.border-partial {
        padding-top: $spacing-050;
    }

    .pagination-control {
        margin: $spacing-200;
    }
}
</style>
